/* eslint-disable react/no-unknown-property */
import React from 'react';
import { string } from 'prop-types';
import './avataar-iframe.style.scss';

export const AvataarIFrame = ({ avataarExperienceLink }) => {
  return (
    <iframe
      id="avtrIframe"
      title="Avataar Iframe"
      src={avataarExperienceLink}
      top="0"
      frameBorder="10"
      className="avatar-iframe"
      allow="camera;microphone;gyroscope;accelerometer;"
    />
  );

};

AvataarIFrame.propTypes = {
  avataarExperienceLink: string
};

AvataarIFrame.defaultProps = {
  avataarExperienceLink: ''
};

export default AvataarIFrame;